module.exports = __webpack_public_path__ + "static/media/exergysystems_logo_login.d4faf2c9.png";